import styled from 'styled-components'
import { getTextAlign } from '../../../utils/CssUtils'
import { ColumnFieldProperties } from '../maintain-table/styled'

export const SymbolFieldStyled = styled.div.attrs((props: ColumnFieldProperties) => ({}))<ColumnFieldProperties>`
    text-align: ${(props) => getTextAlign(props.textAlign)};

    width: 100%;
`
